import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { Material, MaterialService } from "../api/generated";
import { useAuthContext } from "../lib/use-auth";

export const Route = createFileRoute("/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="flex space-x-4">
        <Link to="/employee/register" className="btn btn-xl btn-neutral">
          Medewerker aanmelden
        </Link>
        <Link to="/employee/issue" className="btn btn-xl btn-neutral">
          Materiaal uitgeven
        </Link>
        <Link to="/employee/return" className="btn btn-xl btn-neutral">
          Materiaal inneemen
        </Link>
      </div>
    </div>
  );
}
